import { render, staticRenderFns } from "./OrganiserView.vue?vue&type=template&id=6ce0e9c9&scoped=true"
import script from "./OrganiserView.vue?vue&type=script&lang=js"
export * from "./OrganiserView.vue?vue&type=script&lang=js"
import style0 from "./OrganiserView.vue?vue&type=style&index=0&id=6ce0e9c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce0e9c9",
  null
  
)

export default component.exports